/** Biome / dimension-specific mob spawn weight tables. */

export const NETHER_HOSTILE_SPAWN_WEIGHTS = [
  { type: 'skeleton_archer', w: 0.28 },
  { type: 'skeleton', w: 0.24 },
  { type: 'zombie', w: 0.2 },
  { type: 'spider', w: 0.09 },
  { type: 'creeper', w: 0.07 },
  { type: 'enderman', w: 0.12 }
];

export const END_HOSTILE_SPAWN_WEIGHTS = [
  { type: 'enderman', w: 0.6 },
  { type: 'skeleton', w: 0.24 },
  { type: 'skeleton_archer', w: 0.1 },
  { type: 'spider', w: 0.06 }
];

export const OUTPOST_HOSTILE_SPAWN_WEIGHTS = [
  { type: 'pillager', w: 0.34 },
  { type: 'raider_brute', w: 0.2 },
  { type: 'skeleton_archer', w: 0.16 },
  { type: 'stray', w: 0.12 },
  { type: 'zombie', w: 0.1 },
  { type: 'husk', w: 0.08 }
];

export const MONSTER_DEN_HOSTILE_SPAWN_WEIGHTS = [
  { type: 'spider', w: 0.28 },
  { type: 'creeper', w: 0.18 },
  { type: 'husk', w: 0.16 },
  { type: 'enderman', w: 0.14 },
  { type: 'stray', w: 0.14 },
  { type: 'zombie', w: 0.1 }
];

export const RUIN_HOSTILE_SPAWN_WEIGHTS = [
  { type: 'stray', w: 0.25 },
  { type: 'skeleton', w: 0.2 },
  { type: 'zombie', w: 0.2 },
  { type: 'husk', w: 0.13 },
  { type: 'spider', w: 0.12 },
  { type: 'creeper', w: 0.1 }
];

export const SHIPWRECK_HOSTILE_SPAWN_WEIGHTS = [
  { type: 'drowned', w: 0.34 },
  { type: 'stray', w: 0.18 },
  { type: 'skeleton_archer', w: 0.14 },
  { type: 'husk', w: 0.12 },
  { type: 'spider', w: 0.12 },
  { type: 'zombie', w: 0.1 }
];

export const HAMLET_PASSIVE_SPAWN_WEIGHTS = [
  { type: 'villager', w: 0.22 },
  { type: 'cow', w: 0.2 },
  { type: 'sheep', w: 0.18 },
  { type: 'chicken', w: 0.14 },
  { type: 'goat', w: 0.1 },
  { type: 'pig', w: 0.08 }
];

export const TRIBE_PASSIVE_SPAWN_WEIGHTS = [
  { type: 'villager', w: 0.1 },
  { type: 'goat', w: 0.22 },
  { type: 'wild_boar', w: 0.24 },
  { type: 'chicken', w: 0.16 },
  { type: 'pig', w: 0.12 },
  { type: 'cow', w: 0.11 }
];

export const WETLAND_PASSIVE_SPAWN_WEIGHTS = [
  { type: 'duck', w: 0.28 },
  { type: 'wild_boar', w: 0.2 },
  { type: 'pig', w: 0.18 },
  { type: 'chicken', w: 0.14 },
  { type: 'cow', w: 0.12 },
  { type: 'sheep', w: 0.08 }
];

export const MOUNTAIN_PASSIVE_SPAWN_WEIGHTS = [
  { type: 'goat', w: 0.36 },
  { type: 'sheep', w: 0.22 },
  { type: 'cow', w: 0.14 },
  { type: 'wild_boar', w: 0.14 },
  { type: 'chicken', w: 0.14 }
];

export const BREEDABLE_PASSIVE_TYPES = new Set(['cow', 'sheep', 'pig', 'chicken', 'goat', 'wild_boar', 'duck']);

export const PASSIVE_BREED_FOOD = {
  cow: new Set(['wheat', '68']),
  sheep: new Set(['wheat', '68']),
  pig: new Set(['wheat', 'berry', 'blueberry']),
  chicken: new Set(['wheat_seed', 'wheat']),
  goat: new Set(['wheat', '68']),
  wild_boar: new Set(['wheat', 'berry', 'blueberry']),
  duck: new Set(['wheat_seed', 'wheat'])
};
